import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteAnaliseMercadoClassificacao } from '../cliente-analise-mercado-classificacao';
import { ClienteAnaliseMercadoClassificacaoSearch } from '../cliente-analise-mercado-classificacao-search';
import { ClienteAnaliseMercadoClassificacaoSearchTotal } from '../cliente-analise-mercado-classificacao-search-total';
import { ClienteAnaliseMercadoFilter } from '../../adapters';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoClassificacaoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisemercado/classificacao`;
    }

    /** Pesquisa as análises de mercado de clientes */
    search(filter: ClienteAnaliseMercadoFilter, orderBy: number, orderByDir: string,  limit: number, offset: number): Observable<ClienteAnaliseMercadoClassificacaoSearch[]> {
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<ClienteAnaliseMercadoClassificacaoSearch[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa das análises de mercado de clientes */
    getSearchTotais(filter: ClienteAnaliseMercadoFilter): Observable<ClienteAnaliseMercadoClassificacaoSearchTotal> {
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClienteAnaliseMercadoClassificacaoSearchTotal>(`${this.pathApi}/total`, {params});
    }

    /** Obtem do lançamento da classificação através do cliente, ano e grupo de classificação informados */
    findIDByClienteAnoGrupoClassificacao(idCliente: number, ano: number, idGrupoClassificacao: number): Observable<ClienteAnaliseMercadoClassificacao> {
        return this.customHttp.get<ClienteAnaliseMercadoClassificacao>(`${this.pathApi}/cliente/${idCliente}/ano/${ano}/grupoclassificacao/${idGrupoClassificacao}`);
    }
}
